// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
import { ModuleHeaderUi } from '../_components/ui';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let BoxesModuleUi = class BoxesModuleUi extends AbstractModuleUi {
};
BoxesModuleUi = __decorate([
    Component({
        name: 'BoxesModuleUi',
        components: { ModuleHeaderUi },
        template: `
    <section class="boxes-module" :class="[moduleColoredClass, getThemeByBgClass]" :style="{ backgroundColor: customColor }">
      <div class="container">
        <div class="row">
          <div class="col">

            <!-- Heading -->
            <ModuleHeaderUi v-if="module.content.header" :header="module.content.header" />

            <!-- Boxes -->
            <ul v-if="module.content.boxes && module.content.boxes.length"
                class="boxes-module__list list-unstyled">
              <li v-for="(box, index) in module.content.boxes" :key="index"
                  class="boxes-module__list__item boxes-module__box">
                <!-- Heading -->
                <h3 v-if="box.heading" v-html="box.heading" class="boxes-module__box__heading" />

                <!-- Items -->
                <ul v-if="box.list && box.list.length" class="boxes-module__box__list list-unstyled">
                  <li v-for="(item, index) in box.list" :key="item + index" v-html="item" class="boxes-module__box__list__item" />
                </ul>

                <!-- Text -->
                <p v-if="box.text" v-html="box.text" class="boxes-module__box__text" />
              </li>
            </ul>
            <!-- END | Boxes -->

          </div>
        </div>
      </div>
    </section>
  `
    })
], BoxesModuleUi);
export { BoxesModuleUi };
